import React from 'react';
import PropTypes from 'prop-types';
import Moment from 'moment';
import _ from 'underscore';
import Select from 'views/anyguide/layout/uikit/select';

import './index.scss';

const MonthOptions = (function () {
  let monthNames = Moment.months();

  return _.range(1, 13).map((idx) => {
    return { text: monthNames[idx - 1], value: idx };
  });
})();

const YearOptions = (function () {
  return _.range(Moment().year() - 100, Moment().year()).map((idx) => {
    return { text: idx, value: idx };
  });
})();

function buildDayOptions(month, year) {
  let noDays = Moment(`1/${month}/${year}`, 'DD/MM/YYYY').daysInMonth();
  return _.range(1, noDays + 1).map((idx) => {
    return { text: idx, value: idx };
  });
}

const initialState = {
  day: '',
  month: '',
  year: '',
};

export default class DateDropdowns extends React.Component {
  static displayName = 'DateDropDowns';

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.object,
  };

  static defaultProps = {
    value: null,
  };

  constructor(props) {
    super(props);
    this._setInitialState();
  }

  _setInitialState() {
    let state = initialState;

    if (this.props.value) {
      let { day, month, year } = this.props.value;

      state = { day, month, year };
    }

    this.state = state;
  }

  _date() {
    let { day, month, year } = this.state;

    return { day, month, year };
  }

  fieldChanged(fieldName, fieldValue) {
    this.setState({ [`${fieldName}`]: fieldValue });
    this.props.onChange(this._date());
  }

  render() {
    return (
      <div className="DateDropdowns Select-Wrapper">
        <Select
          className="DateDropdowns-select"
          name="day"
          value={this.state.day}
          key={`${this.state.month}${this.state.year}`}
          placeholder="Day"
          onChange={this.fieldChanged.bind(this, 'day')}
          options={buildDayOptions(this.state.month, this.state.year)}
        />
        <Select
          className="DateDropdowns-select"
          name="month"
          value={this.state.month}
          placeholder="Month"
          onChange={this.fieldChanged.bind(this, 'month')}
          options={MonthOptions}
        />
        <Select
          className="DateDropdowns-select"
          name="year"
          value={this.state.year}
          placeholder="Year"
          onChange={this.fieldChanged.bind(this, 'year')}
          options={YearOptions}
        />
      </div>
    );
  }
}
